import logo from "./logo.svg";
import ReactPlayer from "react-player";
import "./App.css";
import { useState } from "react";
import useWindowSize from "react-use/lib/useWindowSize";
import Confetti from "react-confetti";
import { Button } from "@mui/material";

const isBoy = true;

function App() {
  const [blocked, setBlocked] = useState(true);
  const { width, height } = useWindowSize();

  let text;
  let backgroundColor;
  let youtubeLink;
  let audio;

  if (isBoy) {
    text = "It's a BOY!!!";
    backgroundColor = "#89CFF0";
    youtubeLink = "https://youtu.be/l5aZJBLAu1E?si=wDNO6gooUbTRqA2L&t=50";
    audio = new Audio("/Its_Raining_Men.mp3");
  } else {
    text = "It's a GIRL!!!";
    backgroundColor = "#f8b9d4";
    youtubeLink = youtubeLink =
      "https://youtu.be/PIb6AZdTr-A?si=2JELVuKGe_x4Lc0m&t=30";
  }

  function reveal() {
    if (blocked) {
      setBlocked(false);
      audio.currentTime = 50;
      audio?.play();
    }
  }

  return (
    <div
      className="App"
      tabIndex="0"
      onKeyDown={(e) => {
        if (e.key === " ") {
          reveal();
        }
      }}
    >
      {blocked ? (
        <header className="App-header">
          <h1>Press Space Bar to Reveal</h1>
          <h5>OR</h5>
          <Button
            variant="contained"
            size="large"
            onClick={() => {
              reveal();
            }}
          >
            Press
          </Button>
        </header>
      ) : (
        <header
          className="App-header"
          style={{ backgroundColor: backgroundColor }}
        >
          <h1>{text}</h1>
          {/* <ReactPlayer style={{ maxWidth: "100%" }} url={youtubeLink} playing /> */}
          <Confetti width={width} height={height} />
          <div
            style={{ display: "flex", flexDirection: "row", maxWidth: "100%", justifyContent: "space-between" }}
          >
            <img
              alt="banana-dance"
              src="/banana-cheerer.gif"
              style={{ flex: 1, maxWidth: "30%" }}
            />
            <img
              alt="banana-dance"
              src="/banana-cheerer.gif"
              style={{ flex: 1, maxWidth: "30%" }}
            />
            <img
              alt="banana-dance"
              src="/banana-cheerer.gif"
              style={{ flex: 1, maxWidth: "30%" }}
            />
          </div>
        </header>
      )}
    </div>
  );
}

export default App;
